<h1 mat-dialog-title>Salva ricerca</h1>
<div mat-dialog-content>
  <form #form="ngForm">
    <mat-form-field>
      <mat-label>Search name</mat-label>
      <input type="text" name="searchTitle" min="1" max="30" matInput [(ngModel)]="searchTitle" required>
    </mat-form-field>
  </form>
</div>
<div mat-dialog-actions>
  <button class="button button-stackoverflow button-xs" [disabled]="form.invalid" [mat-dialog-close]="{searchTitle: this.searchTitle}" (click)="onYesClick()">Conferma</button>
  <button class="button button-lastfm button-xs ml-1" (click)="onNoClick()">Cancella</button>
</div>
